import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconTriangleRight = props => (
  <SvgIcon {...props} viewBox="0 0 5 10">
    <path d="m0 0 5 5-5 5v-10z" />
  </SvgIcon>
);

export default IconTriangleRight;



// WEBPACK FOOTER //
// ./src/components/icons/IconTriangleRight.js